/**
 * 实体：海康播放器参数
 * @author 谢长春 2023-07-21
 */
export default class HikStreamVO {
  /**
   *
   * @param key {string} 播放器标识，播放中断时发送重连通知，可以通过这个识别是哪台设备
   * @param playback {boolean} 当前是否录像回放。true:是，false:否
   * @param protocol {string} 拉流协议
   * @param url {string} 拉流地址
   * @param list {array} 录像回放时间切片：playback=true 时这里才有数据，前端要处理逻辑一段播放完之后要切换下一段
   */
  constructor({
                key
                , playback
                , protocol
                , url
                , list
              }) {

    /**
     * 播放器标识，播放中断时发送重连通知，可以通过这个识别是哪台设备
     * @type {string}
     */
    this.key = key
    /**
     * 当前是否录像回放。true:是，false:否
     * @type {boolean}
     */
    this.playback = playback || false
    /**
     * 拉流协议
     * @type {string}
     */
    this.protocol = protocol
    /**
     * 拉流地址
     * @type {string}
     */
    this.url = url
    /**
     * 录像回放时间切片：playback=true 时这里才有数据，前端要处理逻辑一段播放完之后要切换下一段
     * @type {array}
     */
    this.list = list || []
  }
}



// WEBPACK FOOTER //
// ./src/components/player/HikStreamVO.js